/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Type_Menu_TitleInputs */



/**
* | output |
* | --- |
* | "Choose a conversation type" |
*
* @param {Meeting_Type_Menu_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_type_menu_title = /** @type {((inputs?: Meeting_Type_Menu_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Type_Menu_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Kies een gesprekstype")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez un type de conversation")
	return /** @type {LocalizedString} */ ("Choose a conversation type")
});